module.exports = __webpack_public_path__ + "static/machine03-sq-be6b02d60acba39fab82e90320640130.png";